module.exports = __webpack_public_path__ + "whiteNagorik-a0b7de3dcbb6b50be2f6.svg";